<template>
  <div
    class="auth-wrapper auth-v2"
    :dir="$functions.currentLangDirection()"
  >
    <b-row
      class="auth-inner m-0"
      style="direction: ltr;"
    >
      <!-- Left Text-->
      <b-col
        lg="12"
        class="d-none d-md-flex d-lg-flex align-items-center p-0"
      >
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-0">
          <b-img
            fluid
            :src="imgUrl"
            alt="Register V2"
          />
        </div>
      </b-col>
      <!-- Register-->
      <!-- :style="{ backgroundImage: `url(${backgroundUrl})` }"-->
      <!--  style="background-size: cover;background-position: center;" -->
      <b-col
          lg="4"
          class="d-flex align-items-center auth-bg px-2 p-lg-3 form-auth "
          :style="{ backgroundImage: `url(${backgroundUrl})` }"
          v-bind:class="{ mainbox: !isMobile}"
      style="background-size: cover;background-position: center;direction: rtl;" >
      <!-- Brand logo-->
        <b-link class="brand-logo">
          <h2 class="brand-text text-primary ml-1" />
          <span class="brand-logo">
            <!-- <b-img
              :src="appLogoImage"
            alt="logo"
          />-->
          </span>
        </b-link>
        <!-- /Brand logo-->
        <b-col
            sm="12"
            md="12"
            lg="12"
            style="margin-top: -140px;"
            class="box2 px-xl-2 mx-auto"
        >
          <b-card-title
              title-tag="h2"
              class="font-weight-bold mb-1"
          >
            {{ $t('Add Device') }}
          </b-card-title>
          <b-card-text class="mb-2" />

          <!-- form -->
          <validation-observer
              ref="registerForm"
          >
            <div
                class="auth-register-form mt-2 "
            >
              <p style="font-size: 0.8rem;">
                حتما قبل از این مرحله، از روشن بودن دستگاه ردیاب خود اطمینان حاصل فرمائید.

                پیشنهاد می شود دستور #param را به شماره سیم کارت دستگاه ارسال نمائید و پس از دریافت پاسخ این فرم را تکمیل فرمائید.
              </p>
              <!-- username -->
              <b-form-group
                  :label="$t('IMEI')"
                  label-for="register-name"
              >
                <validation-provider
                    #default="{ errors }"
                    name="IMEI"
                    rules="required"
                >
                  <b-form-input
                      id="v-IMEI"
                      v-model="device.imei"
                      name="IMEI"
                      :state="errors.length > 0 ? false : null"
                      placeholder="IMEI"
                      class="numeric-input"
                      maxlength="15"
                      @keyup="imeiChangeEn($event)"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <b-form-group
                  :label="$t('Sim in device')"
                  label-for="v-Sim"
                  class="numeric-input"
              >
                <b-form-input
                    id="v-Sim"
                    v-model="device.sim"
                    name="Sim"
                    placeholder="09xxxxxxxxx"
                    :disabled="simTimerSeconds !== -1"
                    maxlength="11"
                    @keyup="simChangeEn($event)"
                />
              </b-form-group>

              <b-form-group
                  :label="$t('Title')"
                  label-for="v-title"
              >
                <b-form-input
                    id="v-title"
                    v-model="device.title"
                    name="title"
                    :placeholder="$t('Car name')"
                />
              </b-form-group>
              <b-form-group
                  :label="$t('Vehicle type')"
                  label-for="v-address"
              >
                <b-form-select
                    v-model="selectedCategory"
                    :options="options"
                    :select-size="1"
                />
              </b-form-group>

              <b-button
                  variant="success"
                  block
                  type="submit"
                  :disabled="loading"
                  @click="onChangeImei"

              ><b-spinner
                  v-if="loading"
                  variant="outline-primary"
                  small
              />
                {{ $t('Add') }}
              </b-button>

              <span
                  v-if="simTimerSeconds !== -1"
                  id="simTimerSeconds"
              >
                ({{ $t('Please wait') }}...{{ simTimerSeconds }})
              </span>
            </div>
          </validation-observer>
        </b-col>
      </b-col>
      <!-- /Left Text-->

      <!-- /Register-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BFormSelect, BRow, BCol, BLink, BButton, BForm, BFormCheckbox, BFormGroup, BFormInput, BInputGroup, BImg, BCardTitle, BCardText, BSpinner,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { $themeConfig } from '@themeConfig'
import Vue from 'vue'
import store from '@/store/index'
import User from '@/models/user'
import { functions } from '@/functions'
import Device from '@/models/device'
import DeviceService from '@/services/device.service'
import Config from '../../../config'

Vue.prototype.$functions = functions

export default {
  components: {
    BFormSelect,
    BRow,
    BImg,
    BCol,
    BLink,
    BButton,
    BForm,
    BCardText,
    BCardTitle,
    BFormCheckbox,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BSpinner,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      user: new User('', '', '', '', ''),
      device: new Device('', '', '', '', '', '', '', '', '', ''),
      options: Config.carTypes,
      selectedCategory: '0',
      status: '',
      username: '',
      userEmail: '',
      password: '',
      simTimerSeconds: -1,
      sideImg: require('@/assets/images/pages/login-v2.jpg'),
      backgroundImg: require('@/assets/images/pages/lg.jpg'),
      // validation
      required,
      email,
      loading: false,
      isMobile: Vue.prototype.$functions.isMobile(),
    }
  },
  beforeCreate() {
    const user = JSON.parse(localStorage.getItem('user_first'))
    if (user && 'token' in user && user.token) {
      this.mobile = user.mobile
    } else {
      this.$router.push('/login')
    }
  },
  setup() {
    // App Name
    const { appName, appLogoImage } = $themeConfig.app
    return {
      appName,
      appLogoImage,
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      return this.sideImg
    },
    backgroundUrl() {
      return this.backgroundImg
    },
  },
  mounted() {
    const { isRTL } = $themeConfig.layout
    const formGroup = document.getElementsByClassName('form-auth')
    formGroup[0].style.direction = isRTL ? 'rtl' : 'ltr'
  },
  methods: {
    imeiChangeEn(event) {
      this.device.imei = this.$functions.fixNumbers(event.target.value)
    },
    simChangeEn(event) {
      this.device.sim = this.$functions.fixNumbers(event.target.value)
    },
    changeAppLanguage(lang) {
      localStorage.setItem('locale', lang)
      window.location = '/'
    },
    onChangeImei() {
      if ( this.mobile === this.device.sim) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'خطای شماره سیمکارت',
            text: 'شماره موبایل و سیمکارت داخل دستگاه نمی تواند یکسان باشد.',
            icon: 'XIcon',
            variant: 'danger',
            dir: Vue.prototype.$functions.currentLangDirection(),
          },
        })
        return false
      }
      return new Promise((resolve, reject) => {
        this.$refs.registerForm.validate()
          .then(async success => {
            if (success) {
              if (this.device.imei) {
                await DeviceService.check({ imei: this.device.imei })
                  .then(
                    res => {
                      if (res.status === 'error') {
                        this.$toast({
                          component: ToastificationContent,
                          props: {
                            title: this.$t('Error'),
                            text: res.message,
                            icon: 'XIcon',
                            variant: 'danger',
                            dir: Vue.prototype.$functions.currentLangDirection(),
                          },
                        })
                        reject(res.message)
                      } else {
                        this.device.userId = res.result.data.userId
                        this.device.resellerId = res.result.data.resellerId
                        this.device.serverId = res.result.data.serverId
                        this.device.modelId = res.result.data.modelId

                        resolve(true)
                        this.onConfigure()
                      }
                    }, error => {
                      this.message = (error.response && error.response.data)
                                || error.message
                                || error.toString()
                      this.$toast({
                        component: ToastificationContent,
                        props: {
                          title: this.$t('Error'),
                          text: this.message,
                          icon: 'XIcon',
                          variant: 'danger',
                          dir: Vue.prototype.$functions.currentLangDirection(),
                        },
                      })
                      reject(new Error('error'))
                    },
                  )
              } else {
                reject(new Error('error'))
              }
            }
          })
      })
    },
    onConfigure() {
      return new Promise((resolve, reject) => {
        if (this.device.imei && this.device.sim) {
          DeviceService.configure(this.device)
            .then(
              res => {
                if (res.status === 'error') {
                  this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: this.$t('Error'),
                      text: res.message,
                      icon: 'XIcon',
                      variant: 'danger',
                      dir: Vue.prototype.$functions.currentLangDirection(),
                    },
                  })
                  reject(res.message)
                } else {
                  const seconds = 30
                  this.simTimerSeconds = seconds
                  this.simTimerPointer = setInterval(async () => {
                    if (this.simTimerSeconds % 5 === 0) {
                      DeviceService.configureStatus(this.device)
                        .then(
                          resp => {
                            if (resp.status === 'error') {
                              reject(res.message)
                            } else {
                              this.simStatus = true
                              resolve(true)
                              this.simTimerSeconds = -1
                              clearInterval(this.simTimerPointer)
                              this.onConfirm()
                              this.$toast({
                                component: ToastificationContent,
                                props: {
                                  title: this.$t('Message'),
                                  text: this.$t('The operation was successful'),
                                  icon: 'XIcon',
                                  variant: 'success',
                                  dir: Vue.prototype.$functions.currentLangDirection(),
                                },
                              })
                            }
                          },
                        )
                    }
                    if (this.simTimerSeconds > 0) {
                      this.simTimerSeconds -= 1
                    } else if (!this.simStatus) {
                      this.simTimerSeconds = -1
                      clearInterval(this.simTimerPointer)
                      this.$toast({
                        component: ToastificationContent,
                        props: {
                          title: this.$t('Error'),
                          text: res.message,
                          icon: 'XIcon',
                          variant: 'danger',
                          dir: Vue.prototype.$functions.currentLangDirection(),
                        },
                      })
                    }
                  }, 1000)
                  resolve(true)
                }
              },
            ).catch(error => {
              this.message = (error.response && error.response.data)
                        || error.message
                        || error.toString()
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: this.$t('Error'),
                  text: this.message,
                  icon: 'XIcon',
                  variant: 'danger',
                  dir: Vue.prototype.$functions.currentLangDirection(),
                },
              })
              reject(this.message)
            })
        }
      })
    },
    onConfirm() {
      return new Promise((resolve, reject) => {
        this.device.category = this.selectedCategory
        if (this.device.imei && this.device.sim && this.device.title) {
          DeviceService.confirm(this.device)
            .then(
              res => {
                if (res.status === 'error') {
                  this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: this.$t('Error'),
                      text: res.message,
                      icon: 'XIcon',
                      variant: 'danger',
                      dir: Vue.prototype.$functions.currentLangDirection(),
                    },
                  })
                  reject(res.message)
                } else {
                  resolve(true)
                  this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: this.$t('Message'),
                      text: this.$t('The operation was successful'),
                      icon: 'XIcon',
                      variant: 'success',
                      dir: Vue.prototype.$functions.currentLangDirection(),
                    },
                  })
                  const user = JSON.parse(localStorage.getItem('user_first'))
                  localStorage.setItem('user', JSON.stringify(user))
                  localStorage.setItem('user_first', '{}')
                 // Vue.prototype.$functions.deviceServerSocketReconnect(() => {
                    this.$router.push('/')
                  //})
                }
              },
            ).catch(error => {
              this.message = (error.response && error.response.data)
                        || error.message
                        || error.toString()
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: this.$t('Error'),
                  text: this.message,
                  icon: 'XIcon',
                  variant: 'danger',
                  dir: Vue.prototype.$functions.currentLangDirection(),
                },
              })
              reject(this.message)
            })
        }
      })
    },
    mobileChangeEn(event) {
      this.user.mobile = this.$functions.fixNumbers(event.target.value)
    },
  },
}
/* eslint-disable global-require */
</script>

<style lang="scss">
[dir=ltr], [dir=ltr] .ltr * {
  direction: ltr !important;
  text-align: left;
}
[dir=rtl] .d-block {
  direction: rtl !important;
  text-align: right;
}
[dir=ltr] .d-block {
  direction: ltr !important;
  text-align: left;
}

@import '../../@core/scss/vue/pages/page-auth.scss';
.brand-logo img{
  width: 70px;
}
.auth-wrapper .auth-bg{
  background-color: #232633;
  color: #fff;
}
.auth-wrapper label,.auth-wrapper span,.auth-wrapper h2,.auth-wrapper .brand-text{
  color: #fff !important;
}
 .mainbox{
   background: #344935d6!important;
   position: absolute;
   top: 10%;
   margin-left: auto;
   margin-right: auto;
   left: 0;
   right: 0;
   width: 400px;
   height: 540px;
   border-radius: 2%;
}
 .mainbox .box2{
   margin-top: -40px !important;
}
</style>
